import type { LayoutType } from 'types';
import type { TemplateFormsState } from '../index';
import { generateGridPlaceholders } from 'utils/section/gridUtils';
import { initialItem } from './addNewSection';
import { findTemplateSectionIndex } from '../utils/nameUniqueness';

interface Payload {
  sectionName: string;
  subTabId: string;
  layoutType: LayoutType;
  tabId?: string | null;
}

export const removeSubTab = (state: TemplateFormsState, { payload }: { payload: Payload }) => {
  const { sectionName, subTabId, layoutType, tabId } = payload;
  const sections = state[layoutType].sections;

  const sectionIndex = findTemplateSectionIndex(sections, sectionName, tabId);
  if (sectionIndex === -1) return;

  const section = sections[sectionIndex];

  if (section.subTabs) {
    section.subTabs = section.subTabs.filter((st) => st.id !== subTabId);
  }

  // Delete all items that belonged to the deleted sub-tab.
  const realItems = section.items.filter((item) => item.itemGuid && item.subTabId !== subTabId);

  // If only one (or zero) sub-tabs remain, collapse back to the implicit default
  // sub-tab: clear subTabs entirely and reset all remaining items to subTabId === null.
  // A single sub-tab is semantically equivalent to no sub-tabs.
  if ((section.subTabs?.length ?? 0) <= 1) {
    section.subTabs = null;
    section.items = generateGridPlaceholders(
      realItems.map((item) => ({ ...item, subTabId: null })),
      section.sizeX,
      section.sizeY,
      initialItem,
      []
    );
    return;
  }

  // Multiple sub-tabs remain: regenerate placeholders for all remaining sub-tabs.
  const remainingSubTabIds = (section.subTabs ?? []).map((st) => st.id);
  section.items = generateGridPlaceholders(realItems, section.sizeX, section.sizeY, initialItem, remainingSubTabIds);
};
